export function getAccountTypeTranslationKey(
    accountType: 'REPAYMENT_LOANS' | 'CHARGE_CARDS' | 'CREDIT_FACILITY' | 'UNKNOWN',
) {
    switch (accountType) {
        case 'REPAYMENT_LOANS':
            return 'field.repayment-loans.label';
        case 'CHARGE_CARDS':
            return 'field.charge-cards.label';
        case 'CREDIT_FACILITY':
            return 'field.credit-facility.label';
        default:
            return 'field.repayment-loans.label';
    }
}
